import { render, staticRenderFns } from "./Transactionlog.vue?vue&type=template&id=138afa3c&scoped=true"
import script from "./Transactionlog.vue?vue&type=script&lang=js"
export * from "./Transactionlog.vue?vue&type=script&lang=js"
import style0 from "./Transactionlog.vue?vue&type=style&index=0&id=138afa3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138afa3c",
  null
  
)

export default component.exports